import { UnitCostSource, UnitCostSourceLabels } from '@recurrency/core-api-schema/dist/common/enums';

// Supplier override costing is currently only supported for planning costing and UnitCostSettingLabel is used specifically for inventory costing.
// For that reason we explicitly define a subset of UnitCostSource valid for inventory cost, omitting supplier override costs.

export type InventoryUnitCostSource =
  | UnitCostSource.Fifo
  | UnitCostSource.MovingAverage
  | UnitCostSource.Standard
  | UnitCostSource.LastPurchase
  | UnitCostSource.Supplier;

export const unitCostSettingLabelMap = (settingValue?: InventoryUnitCostSource) =>
  UnitCostSourceLabels[settingValue ?? UnitCostSource.MovingAverage];
